var render = function render(){var _vm=this,_c=_vm._self._c;return (this.__isDisplay(this.isImportant))?_c('div',{staticClass:"l_important"},[_c('div',{staticClass:"c_important__info"},[_c('a',{staticClass:"c_important__link",on:{"click":_vm.tapLink}},[_c('span',{staticClass:"c_important__title"},[_vm._v(_vm._s(this.title))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }